import React, { useState } from 'react'
import {
  AssociationWrap,
  BlenderImg,
  ContactItem,
  FacebookDesc,
  FacebookTitle,
  FacebookWrap,
  FooterContainer,
  FooterLogo,
  FooterTitle,
  FooterUpCenterWrap,
  FooterUpLeftWrap,
  FooterUpRightWrap,
  FooterUpWrap,
  FooterWrap,
  LinkIcon,
  LinkItem,
  LinkListTitle,
  LinkListWrap,
  MessageUsIcon,
  MessageUsIconWrap,
  NewsletterDesc,
  NewsletterInput,
  NewsletterButton,
  NewsletterTitle,
  SocialMedia,
  TNPImg,
  NewsletterForm,
  FooterDivider,
  FooterDownWrap,
  FooterDownLinkWrap,
  FacebookScore,
  FacebookStar,
  FacebookRoundIcon,
} from './atoms'
import Logo from '../logo.svg'
import facebookScore from './image/facebook-score.webp'
import facebookStar from './image/facebook-star.png'
import facebookRoundIcon from './image/facebook-round-icon.webp'
import tpnImg from './image/tpn.png'
import blenderImg from './image/blender.png'
import intl from 'react-intl-universal'
import { FacebookIcon } from './svg/facebook-icon'
import { InstagramIcon } from './svg/instagram-icon'
import { YoutubeIcon } from './svg/youtube-icon'
import { TwitterIcon } from './svg/twitter-icon'
import { LinkedinIcon } from './svg/linkedin-icon'
import { LOCALE } from '@foxrenderfarm/internals'
import { EmailIcon } from './svg/email-icon'
import { WhatsAppIcon } from './svg/whats-app-icon'
import { Link } from 'gatsby'
import { Tooltip } from '@foxrenderfarm/widgets'
import { useMedia } from 'use-media'
import { TooltipEmail } from '../../..'

const SocialMediaItems = [
  {
    text: 'Facebook',
    link: 'https://www.facebook.com/foxrender/',
    esLink: 'https://www.facebook.com/quique.casas?fref=ts',
    target: '_blank',
    icon: <FacebookIcon />,
  },
  {
    text: 'Instagram',
    link: 'https://www.instagram.com/foxrenderfarm/',
    esLink: 'https://www.instagram.com/foxrenderfarm/',
    target: '_blank',
    icon: <InstagramIcon />,
  },
  {
    text: 'YouTube',
    link: 'https://www.youtube.com/channel/UCc_B8E0FCvaUg1XO7zLRW1g',
    esLink: 'https://www.youtube.com/channel/UCc_B8E0FCvaUg1XO7zLRW1g',
    target: '_blank',
    icon: <YoutubeIcon />,
  },
  {
    text: 'Twitter',
    link: 'https://x.com/foxrenderfarm',
    esLink: 'https://x.com/foxrenderfarm',
    target: '_blank',
    icon: <TwitterIcon />,
  },
  {
    text: 'Linkedin',
    link: 'https://www.linkedin.com/company/foxrender/',
    esLink: 'https://www.linkedin.com/in/quiquecasas',
    target: '_blank',
    icon: <LinkedinIcon />,
  },
]

const messageUsList = [
  {
    key: 'email',
    link: 'service@foxrenderfarm.com',
    esLink: 'service@foxrenderfarm.com',
    icon: <EmailIcon />,
    ariaLabel: 'email',
  },
  {
    key: 'whatsapp',
    link: 'https://api.whatsapp.com/send/?phone=8618124758259&text=Hello.May%20i%20help%20you?',
    esLink: 'https://api.whatsapp.com/send/?phone=8618124758259&text=Hello.May%20i%20help%20you?',
    icon: <WhatsAppIcon />,
    ariaLabel: 'whatsapp',
  },
]

interface Props {
  locale: LOCALE
  origin: string
}

export const Footer = ({ locale, origin }: Props) => {
  const isMobile = useMedia({ maxWidth: 600 })
  const [showEmail, setShowEmail] = useState(false)
  const [userName, setName] = useState('')
  const [email, setEmail] = useState('')
  const pathLocale = locale === LOCALE.EN ? '' : `/${locale}`

  const companyList = [
    {
      text: intl.get('index.footer.company.cloud.rendering'),
      link: `${pathLocale}/cloud-rendering.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.company.pricing'),
      link: `${pathLocale}/pricing.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.company.customer'),
      link: `${pathLocale}/client-works.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.company.about.us'),
      link: `${pathLocale}/about.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.header.about.global.resellers'),
      link: `${pathLocale}/global-partner.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.company.partners'),
      link: `${pathLocale}/partner.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      isHide: locale !== LOCALE.EN,
      text: intl.get('index.footer.company.animation.booster'),
      link: `/animation-workflow-booster.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      isHide: locale !== LOCALE.EN,
      key: 'blog',
      text: intl.get('index.footer.company.blog'),
      useAnchor: true,
      link: `${origin}/share/index/`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'share',
    },
  ]

  const programList = [
    {
      text: intl.get('index.footer.program.referral'),
      link: `${pathLocale}/invite.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.program.goCloud'),
      link: `${pathLocale}/gocloud-program.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.program.goCreation'),
      link: `${pathLocale}/gocreation-program.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.program.goSpark'),
      link: `${pathLocale}/free-render-farm.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.program.FGT.community'),
      link: '/fgt-community.html',
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
  ]

  const supportList = [
    {
      text: intl.get('index.footer.support.download'),
      link: `${pathLocale}/download.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'main',
    },
    {
      text: intl.get('index.footer.support.tutorial'),
      useAnchor: true,
      link: `${origin}/support/rendering-tutorial/`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'support',
    },
    {
      text: intl.get('index.footer.support.raytool'),
      useAnchor: true,
      link: `${origin}/raytools.html`,
      useGatsbyLink: process.env.GATSBY_PACKAGE_NAME === 'legacy-main',
    },
  ]

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    event.currentTarget.setCustomValidity('')
  }

  const handleName = (event: React.FormEvent<HTMLInputElement>) => {
    event.currentTarget.setCustomValidity(intl.get('index.footer.newsletter.name.tip'))
  }
  const handleEmail = (event: React.FormEvent<HTMLInputElement>) => {
    event.currentTarget.setCustomValidity(intl.get('index.footer.newsletter.email.tip'))
  }

  return (
    <FooterContainer>
      <FooterWrap>
        <FooterUpWrap>
          <FooterUpLeftWrap>
            <FooterLogo to={locale === LOCALE.EN ? '/' : `/${locale}`}>
              <img src={Logo} alt='Fox Renderfarm Cloud Render Farm Service' loading='lazy' />
            </FooterLogo>
            <FooterTitle>{intl.get('index.footer.title')}</FooterTitle>
            <FacebookWrap
              href='https://www.facebook.com/foxrender/reviews/'
              target='_blank'
              rel='noopener noreferrer nofollow'
            >
              <FacebookRoundIcon src={facebookRoundIcon} loading='lazy' alt='facebook' />
              <FacebookScore src={facebookScore} loading='lazy' alt='score' />
              <FacebookStar src={facebookStar} loading='lazy' alt='star' />
              <FacebookTitle>{intl.get('index.footer.facebook.title')}</FacebookTitle>
              <FacebookDesc>{intl.get('index.footer.facebook.desc')}</FacebookDesc>
            </FacebookWrap>
            <AssociationWrap>
              <TNPImg loading='lazy' src={tpnImg} alt='Trusted Partner Network' />
              <BlenderImg loading='lazy' src={blenderImg} alt='Blender Development Fund Member' />
            </AssociationWrap>
            <SocialMedia>
              {SocialMediaItems.map((item) => (
                <LinkIcon
                  key={item.text}
                  href={locale === LOCALE.ES ? item.esLink : item.link}
                  target={item.target}
                  rel='noopener noreferrer nofollow'
                  aria-label={item.text}
                >
                  {item.icon}
                </LinkIcon>
              ))}
            </SocialMedia>
          </FooterUpLeftWrap>
          <FooterUpCenterWrap>
            <div>
              <LinkListWrap>
                <LinkListTitle>{intl.get('index.footer.company')}</LinkListTitle>
                {companyList.map((item) =>
                  item.isHide ? null : (
                    <LinkItem
                      as={item.useAnchor || !item.useGatsbyLink ? 'a' : Link}
                      key={item.text}
                      to={item.link}
                      href={item.link}
                    >
                      {item.text}
                    </LinkItem>
                  ),
                )}
                {locale === LOCALE.JP && (
                  <LinkItem as='a' href='/jp/tradelaw.html'>
                    特定商取引法に基づく表示
                  </LinkItem>
                )}
              </LinkListWrap>
              <LinkListWrap $marginTop={30}>
                <LinkListTitle>{intl.get('index.footer.program')}</LinkListTitle>
                {programList.map((item) => (
                  <LinkItem
                    as={item.useGatsbyLink ? Link : 'a'}
                    key={item.text}
                    to={item.link}
                    href={item.link}
                  >
                    {item.text}
                  </LinkItem>
                ))}
              </LinkListWrap>
            </div>
            <div>
              <LinkListWrap>
                <LinkListTitle>{intl.get('index.footer.support')}</LinkListTitle>
                {supportList.map((item) => (
                  <LinkItem
                    as={item.useAnchor || !item.useGatsbyLink ? 'a' : Link}
                    key={item.text}
                    to={item.link}
                    href={item.link}
                  >
                    {item.text}
                  </LinkItem>
                ))}
              </LinkListWrap>
              <LinkListWrap $marginTop={30}>
                <LinkListTitle>{intl.get('index.footer.business')}</LinkListTitle>
                <ContactItem>
                  <p>{intl.get('index.footer.agentContact')}</p>
                  <p>{intl.get('index.footer.agentEmail')}</p>
                </ContactItem>
                <ContactItem>
                  <p>{intl.get('index.footer.marketingContact')}</p>
                  <p>{intl.get('index.footer.marketingEmail')}</p>
                </ContactItem>
              </LinkListWrap>
              <LinkListWrap>
                <LinkListTitle>{intl.get('index.footer.messageUs')}</LinkListTitle>
                <MessageUsIconWrap>
                  {messageUsList.map((item) =>
                    item.key === 'email' ? (
                      <Tooltip
                        key={item.key}
                        content={<TooltipEmail email='service@foxrenderfarm.com' />}
                        handleShow={(v) => setShowEmail(v)}
                        background='#1e1e1e'
                      >
                        <MessageUsIcon
                          as={!isMobile || showEmail ? 'a' : 'div'}
                          key={item.key}
                          href={`mailto:${item.link}`}
                          aria-label={!isMobile || showEmail ? item.ariaLabel : undefined}
                        >
                          {item.icon}
                        </MessageUsIcon>
                      </Tooltip>
                    ) : (
                      <MessageUsIcon
                        key={item.key}
                        href={locale === LOCALE.ES ? item.esLink : item.link}
                        aria-label={item.ariaLabel}
                        rel='noopener noreferrer nofollow'
                      >
                        {item.icon}
                      </MessageUsIcon>
                    ),
                  )}
                </MessageUsIconWrap>
              </LinkListWrap>
            </div>
          </FooterUpCenterWrap>
          <FooterUpRightWrap>
            <NewsletterTitle>{intl.get('index.footer.newsletter')}</NewsletterTitle>
            <NewsletterDesc>{intl.get('index.footer.newsletter.desc')}</NewsletterDesc>
            <NewsletterForm
              action='https://foxrenderfarm.us9.list-manage.com/subscribe/post?u=b1e935ce029f8692c424fdc2d&amp;id=4d8ac36526'
              method='post'
              id='mc-embedded-subscribe-form'
              name='mc-embedded-subscribe-form'
              target='_blank'
            >
              <NewsletterInput
                placeholder={intl.get('index.footer.newsletter.name')}
                $marginBottom={20}
                title={intl.get('index.footer.newsletter.name.tip')}
                value={userName}
                onChange={(e) => setName(e.target.value)}
                name='FNAME'
                id='mce-FNAME'
                required
                onInput={handleInput}
                onInvalid={handleName}
              />
              <NewsletterInput
                placeholder={intl.get('index.footer.newsletter.email')}
                title={intl.get('index.footer.newsletter.email.tip')}
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name='EMAIL'
                id='mce-EMAIL'
                required
                onInput={handleInput}
                onInvalid={handleEmail}
              />
              <NewsletterButton type='submit' name='subscribe' id='mc-embedded-subscribe'>
                {intl.get('index.footer.newsletter.subscribe')}
              </NewsletterButton>
            </NewsletterForm>
          </FooterUpRightWrap>
        </FooterUpWrap>
        <FooterDivider />
        <FooterDownWrap>
          Copyright © 2025 FoxRenderfarm.com. All Rights Reserved.
          <FooterDownLinkWrap>
            <LinkItem as='a' href={`${origin}/term-of-service.html`}>
              {intl.get('index.footer.terms')}
            </LinkItem>
            <LinkItem as='a' href={`${origin}/privacy.html`}>
              {intl.get('index.footer.privacy')}
            </LinkItem>
          </FooterDownLinkWrap>
        </FooterDownWrap>
      </FooterWrap>
    </FooterContainer>
  )
}
